
/**
 * mode:
 * the first value used for identify the 'storeMode' in store
 * add 'custom-input' to make it show with input field
 * more config in 'productFilterSliderInputMixins'
 */

import Multiselect from 'vue-multiselect';
import productFilterSliderInputMixins from '~/mixins/productFilterSliderInputMixins.js';

export default {
    name: "FilterSliderMobile",
    components: {
        Multiselect,
    },
    mixins: [productFilterSliderInputMixins],
    props: {
      filterTitle: {
        type: String,
        required: true,
        default: '',
      },
      actualValue: {
        required: true,
        // default: () => {},
      },
      filterOptions: {
        type: Array,
        required: true,
        default: () => [],
      },
      sliderFixedRange: {
        type: Array,
        required: true,
        default: () => [],
      },
      mode: {
        type: String,
        required: false,
        default: 'default',
      },
      step: {
        type: Number,
        required: false,
        default: 1000,
      }
    },
    data() {
      return {
        value: null,
        options: [0, 0],
        tempValue: this.actualValue,
        placeholderValue: { value: ['', ''], text: this.filterTitle },
        displayValue: this.actualValue,

        fixedRange: [parseInt(this.sliderFixedRange[0] ?? '0'), parseInt(this.sliderFixedRange[1] ?? '100')],
        isBlock: false,

        sliderInternalValue: this.actualValue.value,
        marks: this.generateMarks(parseInt(this.sliderFixedRange[0] ?? '0'), parseInt(this.sliderFixedRange[1] ?? '100'), this.step),
        // storeMode: this.$store.getters['modal/showDisplayMobileFilter'].mode,
        wrapperWidth: 0,
        showPlaceholderValue: true,
        inputType: 'number',
      }
    },
    mounted() {
        const type = this.mode.split(' ');
        const storeMode = this.$store.getters['modal/showDisplayMobileFilter'].mode;

        if ( this.customInput ) {
          // Force show number keyboard on touch device
          if ( this.isMobile() ) this.inputType = 'tel';
          this.$nextTick(() => {
            if (type[0] == storeMode) {
              this.$refs.dropdownWrapper.toggleDropdown();
            }
          })
        } else {
          this.wrapperWidth = this.$refs.filtercontainer.querySelector('.filter-wrapper').offsetWidth;
          this.$nextTick(() => {
            if (type[0] == storeMode) {
                this.$refs.multiselect.activate();
            }
          })
        }
    },
    methods: {
        onDragged(value, index) {
            this.sliderInternalValue = value;
        },
        generateMarks(start, end, step = 1000) {
            const resultMarks = [];
            for (let i = start; i <= end; i += step) {
                resultMarks.push(i);
            }
            return resultMarks;
        },
        handleAdjustSliderWidth() {
            // console.log(this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper'))
            this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper').style.width = `${this.wrapperWidth}px`;
            if (this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single')) {
                this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single').style.width = `90%`;
            }
            this.showPlaceholderValue = false;
            // console.log(this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper'))

        },
        handleAdjustSelection() {
            if (this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single')) {

                this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single').style.width = `100%`;
            }
            this.showPlaceholderValue = true;

        },
        isMobile() {
          // for detecting iPad pro workaround
          if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) return true;

          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
    }
}
